import React from "react";

export const handleDurationTime = (received_minutes) => {
  const hours = Math.floor(received_minutes / 60);
  const minutes = received_minutes % 60;
  return (
    <div>
      {hours > 0 ? (
        <span className={"duration-hours"}>{hours.toFixed(0)}h </span>
      ) : null}
      <span className={"duration-time-minutes"}>{minutes.toFixed(0)}m </span>
    </div>
  );
};
